function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesRoomWifiFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 28h24V4H4v24zm24 2c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h24z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10c-3.56 0-6.76 1.57-8.96 4.04l1.41 1.41c1.83-2.11 4.53-3.46 7.54-3.46 2.8 0 5.33 1.16 7.15 3.02l1.34-1.49a11.956 11.956 0 00-8.49-3.53L16 10z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14c-2.46 0-4.66 1.12-6.13 2.87l1.42 1.42C12.39 16.9 14.09 16 16 16c1.78 0 3.37.78 4.47 2.01l1.34-1.49A7.956 7.956 0 0016 14z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18c-1.36 0-2.56.68-3.28 1.72l1.46 1.46C14.49 20.49 15.19 20 16 20c.76 0 1.41.43 1.75 1.05l1.37-1.53A3.973 3.973 0 0016 18z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesRoomWifiFilled;